import { render } from "./TransferedPacket.vue?vue&type=template&id=54c930f5"
import script from "./TransferedPacket.vue?vue&type=script&lang=js"
export * from "./TransferedPacket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__